import { render, staticRenderFns } from "./ListItemActions.vue?vue&type=template&id=b8e3b632"
import script from "./ListItemActions.vue?vue&type=script&lang=js"
export * from "./ListItemActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports